import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextareaAutosize,
  Typography,
} from '@material-ui/core'
// Note: This form covers 2 use cases "Watch and record" and "Watch and type"

const Feedback = ({ values, onChange }) => {
  return (
    <Box sx={{ p: 2, border: '1px solid lightGray' }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Add 5-Star Review and student Comments at the end of the lesson.
      </Typography>

      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.rating}
              name="rating"
              onChange={onChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label="Implement 5 Star Ratings ?"
        />
        {values?.rating &&
          <TextareaAutosize
            name="feedbackQuestion"
            onChange={onChange}
            value={values.feedbackQuestion}
            minRows={4}
            placeholder="Enter Topic/Title/Question/Parameter for Rating."
            style={{ width: '400px', padding: 5 }}
          />
        }
        <FormControlLabel
          control={
            <Checkbox
              checked={values.comment}
              name="comment"
              onChange={onChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label="Implement Review Writing ?"
        />
      </FormGroup>
      {values?.comment && (
        <TextareaAutosize
          name="feedbackPlaceholder"
          onChange={onChange}
          value={values.feedbackPlaceholder}
          minRows={4}
          placeholder="Enter Topic/Title/Question/Parameter for Comment."
          style={{ width: '400px', padding: 5 }}
        />
      )}
    </Box>
  )
}

export default Feedback
